var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning2 = function SvgWarning2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warning2_svg__a)",
    fill: "#E94F66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.41a.675.675 0 0 0-.668.668c0 .364.304.668.668.668.35 0 .668-.304.652-.652A.652.652 0 0 0 6.5 9.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.684 11.777c.42-.724.422-1.587.005-2.309L8.504 2.221A2.274 2.274 0 0 0 6.503 1.06c-.84 0-1.588.435-2.002 1.16L.31 9.473a2.3 2.3 0 0 0 .008 2.322 2.287 2.287 0 0 0 1.996 1.147h8.36c.835 0 1.586-.436 2.009-1.166Zm-.909-.523c-.232.4-.644.638-1.104.638H2.312c-.454 0-.863-.232-1.09-.625a1.265 1.265 0 0 1-.003-1.275L5.41 2.74a1.24 1.24 0 0 1 1.094-.633c.456 0 .865.238 1.093.636l4.187 7.253c.225.39.222.86-.008 1.259Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.334 4.72c-.318.09-.516.38-.516.73l.046.636L6 8.483a.49.49 0 0 0 .5.47.5.5 0 0 0 .5-.486c0-.166 0-.318.016-.487.029-.515.061-1.031.09-1.547.016-.334.046-.668.062-1.002a.825.825 0 0 0-.062-.334.67.67 0 0 0-.772-.377Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h13v13H0z"
  })))));
};
export default SvgWarning2;